import { Control } from 'react-hook-form';

import { Field } from 'coreOld/components';
import { AlignText, InputType } from 'coreOld/enums';
import { Icon } from 'coreOld/elements';
import { InputsWrapper } from 'partsOld/elements';
import { ICostForm } from 'partsOld/types';

import { InputWrapper, Sign, Text } from '../costFormStyle';

const DEFAULT_MIN_QTY = '1';

interface IProps {
  control: Control<ICostForm, object>;
  removeCost?: (index: number) => void;
  index: number;
  minQty: string | number;
  uom: string;
}

const CostItemView = ({ control, index, removeCost, minQty, uom }: IProps) => {
  return (
    <InputsWrapper container spacing={1}>
      <InputWrapper item xs={3.5}>
        <Sign bold>≥</Sign>
        <Field
          type={InputType.TEXTFIELD}
          name={`costItems.${index}.minQuantity`}
          inputProps={{
            control,
            defaultValue: index === 0 ? DEFAULT_MIN_QTY : minQty,
            textAlign: AlignText.RIGHT,
          }}
        />
      </InputWrapper>

      <InputWrapper item xs={3.5}>
        <Sign>{'<'}</Sign>
        <Field
          type={InputType.TEXTFIELD}
          name={`costItems.${index}.maxQuantity`}
          inputProps={{
            control,
          }}
        />
      </InputWrapper>

      <InputWrapper item xs={3.5}>
        <Sign>{uom || '-'}</Sign>
        <Field
          type={InputType.TEXTFIELD}
          name={`costItems.${index}.cost`}
          inputProps={{
            control,
            textAlign: AlignText.RIGHT,
          }}
        />
      </InputWrapper>

      <InputWrapper item xs={0.5}>
        <Text marginRight={10}>/{uom || '-'}</Text>

        <Icon name={Icon.CLEAR} onClick={() => removeCost(index)} />
      </InputWrapper>
    </InputsWrapper>
  );
};

export default CostItemView;
